<div class="recovery">
  <div class="container h-100">
    <div class="row align-items-center h-100 justify-content-center">
      <div class="card rounded-0 card-recovery border-0">
        <div class="text-center mb-3">
          <img src="assets/images/header-logo.png" />
        </div>

        <div class="card-body">

          <crm-alert #alert></crm-alert>

          <form *ngIf="isCodeValid" [formGroup]="recoveryForm" name="form" class="form" (ngSubmit)="onSubmit()">

            <div class="form-group row">
              <label for="inputPassword" class="col-sm-3 col-form-label">New Password</label>
              <div class="col-sm-9">
                <input type="password" formControlName="USER_PASSWORD" id="inputPassword" name="USER_PASSWORD" class="form-control rounded-0"
                  placeholder="Password" required />
                <div class="form-text text-danger" *ngIf="recoveryForm.controls['USER_PASSWORD'].invalid && (recoveryForm.controls['USER_PASSWORD'].dirty || recoveryForm.controls['USER_PASSWORD'].touched)">
                  <div *ngIf="recoveryForm.controls['USER_PASSWORD'].errors['pattern']">
                      Password must be of 12 characters including at least 1 number and 1 capital letter</div>
                </div>
              </div>
            </div>

            <div class="form-group row">
              <label for="inputRetypePassword" class="col-sm-3 col-form-label">Retype Password</label>
              <div class="col-sm-9">
                <input type="password" formControlName="USER_CONFIRM_PASSWORD" id="inputRetypePassword" name="USER_CONFIRM_PASSWORD"
                  class="form-control rounded-0" placeholder="Password" required />
                <div class="form-text text-danger" *ngIf="recoveryForm.controls['USER_CONFIRM_PASSWORD'].invalid && (recoveryForm.controls['USER_CONFIRM_PASSWORD'].dirty || recoveryForm.controls['USER_CONFIRM_PASSWORD'].touched)">
                  <div *ngIf="recoveryForm.controls['USER_CONFIRM_PASSWORD'].errors['minlength']">
                      Password must be of 12 characters including at least 1 number and 1 capital letter</div>
                  <div *ngIf="recoveryForm.controls['USER_CONFIRM_PASSWORD'].errors['compare']">
                      Password did not match
                    </div>
                </div>
              </div>
            </div>

            <div class="row mt-5">
              <div class="col-6 mx-auto">
                <button [disabled]="!recoveryForm.valid" type="submit" class="btn btn-login btn-lg btn-block rounded-0">
                   Change Password
                </button>
              </div>
            </div>
          </form>

          <div *ngIf="!isCodeValid" class="alert alert-danger text-center">
            <b>Invalid Code</b> <br>
            You have used invalid or already registered code.
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
